<template>
    <div>
        <div v-if="entity && entity_type" style="border: 2px solid #66359b;padding:3px">
            <RecursivePayloadOnSchemaEditor :schema="entity_type.schema" :value="entity.payload" :key_to_show="this.entity_type.name" :intern_key="intern_key" readonly></RecursivePayloadOnSchemaEditor>
        </div>
    </div>
  </template>
    
  <script>
  import GenericTableComponent from '@/components/GenericTableComponent.vue'
  import RecursivePayloadOnSchemaEditor from '@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue'
  import { EntityInstanceApiRepository, EntityTypeApiRepository } from '@/modules/entities/infra/EntitiesApiRepositories'
  export default {
      name: "EntityInstanceViewer",
      components: {
        RecursivePayloadOnSchemaEditor,
      },
      data() {
        return {
            entity_inst_repo: null,
            entity_type_repo: null,
            entity: null,
            entity_type: null,
        }
      },
      props: {
        entity_instance_id: {
          type: String,
          required: true,
        },
        intern_key: {
          type: String,
          required: false,
          default: '',
        },
      },
      async mounted() {
        this.entity_inst_repo = new EntityInstanceApiRepository();
        this.entity_type_repo = new EntityTypeApiRepository();
        await this.loadEntity();
        
      },
      methods: {
        async loadEntity(){
          this.entity = await this.entity_inst_repo.get_instance_by_id(this.entity_instance_id);
          this.entity_type = await this.entity_type_repo.get_type_by_id(this.entity.entity_type_id, true);
          //this.composed_key = this.key_to_show + ' ('+this.entity_type.name+')';
        },
      },
      
    };
    </script>
    
    <style scoped>
    .nested-section {
      padding-left: 10px;
      /*border-left: 1px solid #ccc; */
      margin-top: 10px;
    }
    </style>
    